
<div class="d-flex pager align-items-center">
    <button type="button" class="btn btn-secondary" [disabled]="PageIndex == 0" (click)="GoToFirst()">&lt;&nbsp;&lt;</button>
    <button type="button" class="btn btn-secondary" [disabled]="PageIndex == 0" (click)="GoToPrevious()">&lt;</button>
    <input type="text" class="form-control flex-fill" [(ngModel)]="PageNum">
    <span>of</span>
    <input type="text" class="form-control flex-fill" [value]="GetPageCountDisplay()" disabled>
    <button type="button" class="btn btn-secondary" [disabled]="PageIndex == PageCount - 1" (click)="GoToNext()">&gt;</button>
    <button type="button" class="btn btn-secondary" [disabled]="PageIndex == PageCount - 1" (click)="GoToLast()">&gt;&nbsp;&gt;</button>
</div>